import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { SITE, spotsLeft } from "../config";

const FooterLink = ({ to, children, testId }) => (
  <li>
    <Link to={to} data-testid={testId} className="text-sm text-mist transition-colors hover:text-volt">
      {children}
    </Link>
  </li>
);

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/5">
    <div className="hero-glow absolute inset-0 rotate-180" aria-hidden="true" />
    <div className="container-x relative pb-28 pt-14 sm:py-20 lg:pb-20">
      <div className="max-w-3xl">
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
          Ready for a website that <span className="text-volt glow-text">pulls its weight</span>?
        </h2>
        <p className="mt-4 font-display text-xl font-extrabold tracking-tight text-volt glow-text sm:text-2xl">
          ${SITE.price} flat · Live in 72 hours
        </p>
        <div className="mt-6 flex flex-wrap items-center gap-4">
          <Link to="/book-demo" data-testid="footer-cta-button" className="btn-primary">
            Book a Free Demo <ArrowRight size={16} strokeWidth={2.5} />
          </Link>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-dim">
            Free 20-min demo · No credit card
          </p>
        </div>
      </div>

      <div className="mt-12 grid gap-8 border-t border-white/5 pt-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-dim">
            A website that does more than look good. It gets you leads.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-volt/25 bg-volt/5 px-3 py-1.5 font-mono text-xs text-volt">
            ${SITE.price} founding price · {spotsLeft} of {SITE.totalSpots} spots left
          </p>
        </div>
        <nav aria-label="Site">
          <p className="eyebrow !text-dim">Site</p>
          <ul className="mt-4 space-y-2.5">
            <FooterLink to="/services" testId="footer-link-services">Services</FooterLink>
            <FooterLink to="/pricing" testId="footer-link-pricing">Pricing</FooterLink>
            <FooterLink to="/how-it-works" testId="footer-link-how-it-works">How It Works</FooterLink>
            <FooterLink to="/about" testId="footer-link-about">About</FooterLink>
          </ul>
        </nav>
        <nav aria-label="Company">
          <p className="eyebrow !text-dim">Company</p>
          <ul className="mt-4 space-y-2.5">
            <FooterLink to="/book-demo" testId="footer-link-book-demo">Book a Demo</FooterLink>
            <FooterLink to="/contact" testId="footer-link-contact">Contact</FooterLink>
          </ul>
        </nav>
        <nav aria-label="Legal">
          <p className="eyebrow !text-dim">Legal</p>
          <ul className="mt-4 space-y-2.5">
            <FooterLink to="/privacy" testId="footer-link-privacy">Privacy Policy</FooterLink>
            <FooterLink to="/terms" testId="footer-link-terms">Terms of Service</FooterLink>
          </ul>
        </nav>
      </div>

      <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row sm:items-center">
        <p className="text-xs text-dim">© {new Date().getFullYear()} LeadCerebro. All rights reserved.</p>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-dim">
          First draft in 48h · Live in 72h
        </p>
      </div>
    </div>
  </footer>
);
